module.exports = __webpack_public_path__ + "static/img/login.3ce2348e.png";